"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
require("antd/lib/card/style");
var _card = _interopRequireDefault(require("antd/lib/card"));
require("antd/lib/row/style");
var _row = _interopRequireDefault(require("antd/lib/row"));
require("antd/lib/col/style");
var _col = _interopRequireDefault(require("antd/lib/col"));
require("antd/lib/typography/style");
var _typography = _interopRequireDefault(require("antd/lib/typography"));
var _react = _interopRequireDefault(require("react"));
require("./GroupReviews.less");
var _api = require("./api");
var _utils = require("../../../utils");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _AdminGroupReviews = _interopRequireDefault(require("./AdminGroupReviews"));
var _Button = require("../../../components/Button");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Title = _typography.default.Title;
var GroupReviews = function GroupReviews(_ref) {
  var group = _ref.group;
  var _useGroupAverageRatin = (0, _api.useGroupAverageRating)(group),
    loadingAverageRating = _useGroupAverageRatin.loadingAverageRating,
    averageRating = _useGroupAverageRatin.averageRating;
  var _useAllowedForRoles = (0, _utils.useAllowedForRoles)([_utils.UserRoles.Admin, _utils.UserRoles.SuperAdmin]),
    isReviewsListAvailable = _useAllowedForRoles.isAllowed;
  return /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: loadingAverageRating
  }, /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_col.default, {
    xs: 24,
    className: "mb-30 flex"
  }, /*#__PURE__*/_react.default.createElement(_card.default, {
    className: "custom-card ant-card-shadow ant-card-narrow flex-grow",
    title: /*#__PURE__*/_react.default.createElement(Title, {
      level: 4
    }, "Group Rating and Reviews"),
    bordered: false,
    extra: /*#__PURE__*/_react.default.createElement(_Button.TextButton, {
      underline: false,
      url: (0, _utils.getGroupRatingAndReviewStatisticsCsvUrl)(group.id, (0, _momentTimezone.default)(group.createdAt).utc().format(), (0, _momentTimezone.default)().utc().format())
    }, "Export to CSV Group Rating and Reviews")
  }, /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_col.default, {
    className: "card-label",
    xs: {
      span: 24,
      offset: 0
    },
    sm: {
      span: 4,
      offset: 0
    }
  }, "Stars:"), /*#__PURE__*/_react.default.createElement(_col.default, {
    className: "ant-card-text",
    xs: {
      span: 24,
      offset: 0
    },
    sm: {
      span: 20,
      offset: 0
    }
  }, averageRating.stars || 0)), /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_col.default, {
    className: "card-label",
    xs: {
      span: 24,
      offset: 0
    },
    sm: {
      span: 4,
      offset: 0
    }
  }, "Total:"), /*#__PURE__*/_react.default.createElement(_col.default, {
    className: "ant-card-text",
    xs: {
      span: 24,
      offset: 0
    },
    sm: {
      span: 20,
      offset: 0
    }
  }, averageRating.ratings || 0)), isReviewsListAvailable && /*#__PURE__*/_react.default.createElement(_AdminGroupReviews.default, {
    group: group
  })))));
};
var _default = GroupReviews;
exports.default = _default;